export default {
  sorts: [],
  hasLoadMore: false,
  isFirstLoad: true,
  updateHistory: false,
  filters: {},
  appliedFilter: false,
  query: {},
  browseBy: null,
  browseByFacet: null,
};
